import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import { App } from "./App";
import { Home } from "./pages/Home";
import { Blog } from "./pages/Blog";
import { Post } from "./pages/Post";
import { Topic } from "./pages/Topic";
import { Play } from "./pages/Play";
import { Contact } from "./pages/Contact";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:id" element={<Post />} />
          <Route path="play" element={<Play />} />
          <Route path="contact" element={<Contact />} />
          {/* Any other path is a topic page defined in src/content/pages.json */}
          <Route path=":slug" element={<Topic />} />
        </Route>
      </Routes>
    </HashRouter>
  </React.StrictMode>
);
